import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { appRoutes } from '../../../..';
import { ApiRequestStatus } from '../../../model/api-request';
import { GlobalActions } from '../../../model/global-actions';
import {
  resetUnlockUserState,
  unlockUser,
} from '../../../store/features/user-access/unlock-user/unlock-user-slice';
import { messagesForUnlockUserError } from '../../../store/features/user-access/unlock-user/unlock-user-utils';
import { useAppDispatch, useAppSelector } from '../../redux';

export interface UnlockUserbacks {
  username: string;
  unlockUserRequestStatus: ApiRequestStatus;

  openSuccessDialog: boolean;
  closeSuccessDialog: () => void;

  handleSubmit: () => void;
}

export const useUnlockUser = (actions: GlobalActions): UnlockUserbacks => {
  const { navigate, showToast, closeToast } = actions;

  const { unlockUserRequestStatus, unlockUserError } = useAppSelector(
    (state) => state.features.unlockUser
  );
  const dispatch = useAppDispatch();

  const { username } = useAppSelector((state) => state.data.user);

  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  const { formatMessage } = useIntl();

  const handleSubmit = useCallback(() => {
    dispatch(unlockUser());
  }, [dispatch]);

  const closeSuccessDialog = useCallback(() => {
    setOpenSuccessDialog(false);
    navigate(appRoutes.Login);
  }, [navigate]);

  useEffect(() => {
    if (unlockUserError) {
      const errorMessages = messagesForUnlockUserError(unlockUserError);
      showToast({
        type: 'error',
        title: formatMessage(errorMessages.title),
        description:
          errorMessages.description && formatMessage(errorMessages.description),
        close: closeToast,
      });
      dispatch(resetUnlockUserState());
    }
  }, [unlockUserError, dispatch, formatMessage, showToast, closeToast]);

  useEffect(() => {
    if (unlockUserRequestStatus === 'succeeded') {
      dispatch(resetUnlockUserState());
      setOpenSuccessDialog(true);
    }
  }, [unlockUserRequestStatus, navigate, dispatch]);

  return {
    username,
    unlockUserRequestStatus,

    openSuccessDialog,
    closeSuccessDialog,

    handleSubmit,
  };
};
